import * as React from 'react';
import { Row, Col, Modal, Button } from 'antd';
import strings from '../../eyeguide-localization/strings.settings';
import '../../css/UpdatePassword.scss';
import service from '../../service/apolloclient.service';
import LocalStorage from '../../service/localstorage';
// import Constants from '../common/constants';

const storage = new LocalStorage();

interface IForgotPasswordProps {
    isModalVisible: boolean;
    modalClosed: any;
    userEmail: string;
}

interface IForgotPasswordState {
    isSuccess: boolean;
    isModalVisible: boolean;
    userEmail: string;
}

export default class ForgotPassword extends React.Component<IForgotPasswordProps, IForgotPasswordState> {
    constructor(props: IForgotPasswordProps) {
        super(props);
        this.state = {
            isSuccess: false,
            isModalVisible: this.props.isModalVisible,
            userEmail: this.props.userEmail

        };
    }

    componentWillReceiveProps(nextProps: any) {

        this.setState({
            isModalVisible: nextProps.isModalVisible,
            userEmail: nextProps.userEmail
        });
    }

    render() {
        return (
            <Modal
                className="UpdatePassword"
                title={this.state.isSuccess ? strings.lsSuccessTxt : strings.lsResetPwdTx}
                visible={this.state.isModalVisible}
                width={500}
                bodyStyle={{padding: 0 }}
                maskClosable={false}
                closable={false}
                footer={!this.state.isSuccess ? [
                    <Button 
                            key="Ok" 
                            type="primary"  
                            onClick={() => this.forgotPassword()}
                    >
                    {this.state.isSuccess ? strings.lsOkTxt : strings.lsResetPwdBtnTxt}
                    </Button>,
                    <Button 
                            key="cancel" 
                            type="danger"  
                            onClick={() => this.closeForm()}
                    >
                        {strings.lsCancelTxt}
                    </Button>
                ] : [
                    <Button 
                        key="Ok" 
                        type="primary"  
                        onClick={() => this.forgotPassword()}
                    >
                    {strings.lsOkTxt}
                    </Button>,
                ]}
            >
                {this.state.isSuccess ?
                    <div className="successDiv">
                        {strings.lsResetEmailSentTxt}
                    </div> :
                    <Row className="row">
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="fpLabelFrame">
                            <div className="label">
                                <span><b> {strings.lsEmailAddressTxt}
                                : </b></span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={14} className="fpLabelFrame">
                            <span> {this.state.userEmail} </span>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={5}/>                   
                    </Row>
                }
            </Modal>
        );
    }

    private async forgotPassword() {
        if (!this.state.isSuccess) {
            console.log('');
            let ser = new service();
            let resp = await ser.forgotPassword(storage.getUsername(), this.state.userEmail);
            console.log('forgotpassword resp', resp);
            if (resp.status === 0) {
                this.setState({
                    isSuccess: true
                });
            } 
        } else {
            this.closeForm();
        }
        
    }

    private closeForm() {
        this.setState({
            isModalVisible: false,
            isSuccess: false
        });
        this.props.modalClosed();
        // this.clearForm();
    }

}


// WEBPACK FOOTER //
// ./src/components/settings/forgotPassword.tsx